'use client';

import { createContext } from 'react';
import type { RefObject } from 'react';
import type { MenuSize } from './menuTypes';

type MenuContextValue = {
    size: MenuSize;
    menuRef?: RefObject<HTMLDivElement | null>;
};

export const MenuContext = createContext<MenuContextValue>({
    size: 'sm',
});
